/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';


@Injectable()
export class AuthenticationGuard implements CanActivate, CanActivateChild {
  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const token = localStorage.getItem('R-CRM-TOKEN');
    if (token != null) {
      if (this.jwtHelper.isTokenExpired(token)) {
        this.resetAuthentication(state.url);
        return false;
      } else {
        return true;

        /*
        let decoded = this.jwtHelper.decodeToken(token);

        if("crm.reliantvalue.com" === decoded.aud || "crm-prod.kkgfx4tprq.us-east-2.elasticbeanstalk.com" === decoded.aud)
          return true;
        else{
          this.resetAuthentication(route.parent.queryParams);
          return false;
        }*/
      }
    } else {
      this.resetAuthentication(state.url);
      return false;
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  private resetAuthentication(params: any): void {
    localStorage.removeItem('R-CRM-TOKEN');
    localStorage.removeItem('R-CRM-PROFILE');

    this.router.navigate(['/login'], { queryParams: { url: encodeURI(params) }});
  }

  getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/');
  }
}
